import { useEffect } from 'react';
import { useAuth } from '@/contexts/useAuth';
import { useToast } from '@/contexts/ToastContext';
import {
  registerForcedLogoutHandler,
  unregisterForcedLogoutHandler,
  consumePendingDeactivatedMessage,
} from '@/lib/authSession';

/**
 * Регистрирует toast + logout для принудительного завершения сессии из api/client и WebSocket.
 * Без hard-redirect: logout снимает сессию, ProtectedLayout уводит на /auth, ToastProvider остаётся —
 * тост «аккаунт отключён» виден на экране логина.
 */
export function AuthSessionBridge() {
  const { logout } = useAuth();
  const { showError } = useToast();

  useEffect(() => {
    const pending = consumePendingDeactivatedMessage();
    if (pending) showError(pending);

    registerForcedLogoutHandler(async (message) => {
      showError(message);
      await logout();
    });
    return () => unregisterForcedLogoutHandler();
  }, [logout, showError]);

  return null;
}
